import { CalculationFactorKey } from "../../shared/calculations/calculation-factor-types";
import { CuratedListRedirect } from "./curated-list-redirect";
import {
  BeveragesMain,
  ContinentEmployeeCommutingMain,
  CoolingMain,
  ElectricityMain,
  FlightClassMain,
  FoodMain,
  FugitivesMain,
  HeatingAndFuelMain,
  HomeOfficeMain,
  HotelStaysMain,
  MeansOfTransportMain,
  PrivateAndRentalVehicleMain,
  RailTravelMain,
  RefrigerantMain,
  TransportMain,
  VehicleFuelTypeMain,
  WasteCategoryMain,
  WaterMain,
} from "./lazy-pages";

export const CuratedCalculationFactors = [
  { path: CalculationFactorKey.FUGITIVES, element: <FugitivesMain /> },
  {
    path: CalculationFactorKey.HEATING_AND_FUELS,
    element: <HeatingAndFuelMain />,
  },
  { path: CalculationFactorKey.HOTEL_STAYS, element: <HotelStaysMain /> },
  { path: CalculationFactorKey.TRANSPORT, element: <TransportMain /> },
  {
    path: CalculationFactorKey.WASTE_CATEGORY,
    element: <WasteCategoryMain />,
  },
  { path: CalculationFactorKey.ELECTRICITY, element: <ElectricityMain /> },
  { path: CalculationFactorKey.COOLING, element: <CoolingMain /> },
  {
    path: CalculationFactorKey.MEANS_OF_TRANSPORT,
    element: <MeansOfTransportMain />,
  },
  { path: CalculationFactorKey.HOME_OFFICE, element: <HomeOfficeMain /> },
  { path: CalculationFactorKey.REFRIGERANT, element: <RefrigerantMain /> },
  { path: CalculationFactorKey.FLIGHT_CLASS, element: <FlightClassMain /> },
  {
    path: CalculationFactorKey.CONTINENT_EMPLOYEE_COMMUTING,
    element: <ContinentEmployeeCommutingMain />,
  },
  { path: CalculationFactorKey.RAIL_TRAVEL, element: <RailTravelMain /> },
  {
    path: CalculationFactorKey.VEHICLE_FUEL_TYPE,
    element: <VehicleFuelTypeMain />,
  },
  {
    path: CalculationFactorKey.PRIVATE_AND_RENTAL_VEHICLE,
    element: <PrivateAndRentalVehicleMain />,
  },
  { path: CalculationFactorKey.WATER, element: <WaterMain /> },
  { path: CalculationFactorKey.BEVERAGES, element: <BeveragesMain /> },
  { path: CalculationFactorKey.FOOD, element: <FoodMain /> },
  { index: true, element: <CuratedListRedirect /> },
  { path: "*", element: <CuratedListRedirect /> },
];
